// extracted by mini-css-extract-plugin
export default {"container":"OverlaySpinner_container__LadXv"};